import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { WorkDomainGlobal } from "src/util/types/dataModels/workDomain"

//region Types

export type WorkDomainGlobalDocument = RxDocument<WorkDomainGlobal>
export type WorkDomainGlobalCollection = RxCollection<WorkDomainGlobal>

//endregion

/**
 * Schema for work domain collections
 */
export const workDomainGlobalSchema: RxJsonSchema<WorkDomainGlobal> = {
  title: "Work domain global schema",
  description: "Collection of all work domains",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 128 },
    allows_regular_adhoc: { type: "boolean" },
    allows_corrective_adhoc: { type: "boolean" },
    require_proof_of_presence: { type: "boolean" },
    shorthand_name: { type: "string", maxLength: 48, minLength: 1 },
    organisation: {
      type: "array",
      items: {
        type: "string",
      },
    },
    workspaces: {
      type: "array",
      items: {
        type: "string",
      },
    },
  },
  required: ["id", "designation"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const workDomainGlobalCollectionCreator: RxCollectionCreator = {
  schema: workDomainGlobalSchema,
}
